import { API } from "./config";
import axios from "axios";
// Country API

export const fetchCountriesAPI = (params) => {
  return API.get("/country", { params })
    .then((res) => res)
    .catch((error) => error);
};

// User API

export const fetchUserInfoApi = (payload) => {
  return API.get("/employees/", {
    params: payload,
  }).then((res) => res);
};

// Menus API

export const fetchUserMenusApi = (payload) => {
  return API.get("/imdlGroups?IMDLGroupOnPremSAMAccountName=" + (payload.imdlGroups || "") + "&CountrySk=" + (payload.countrySk || 1))
    .then((res) => res)
    .catch((error) => error);
};

// Product capsules API

export const fetchProductCapsules = (params) => {
  return API.get("/productCapsuleTypes", { params: { 
    CountrySk: params.countrySk
  } })
    .then((res) => res)
    .catch((error) => error);
};

export const fetchBrandOptions = (params) => {
  return API.get("/productBrandOptions", { params: { CountrySk: params.countrySk } })
    .then((res) => res)
    .catch((error) => error);
};

export const fetchCategoryOptions = (params) => {
  return API.get("/ProductCategory", { params: { CountrySk: params.countrySk } })
    .then((res) => res)
    .catch((error) => error);
};

// Product Group API

export const fetchProductsGroupApi = (payload) => {
  return API.get("/productgroups/", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const fetchProductsGroupByIdApi = (id) => {
  return API.get("/productgroups/" + (id || ""))
    .then((res) => res)
    .catch((error) => error);
};

export const filterProductGroupApi = (payload) => {
  return API.get(`/productgroups/`, {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const createProductsGroupApi = (payload) =>
  API.post(`/productgroups`, payload).then((res) => res);

export const updateProductsGroupApi = (payload) =>
  API.put(`/productgroups/${payload.ProductGroupSK}`, payload).then(
    (res) => res
  );

// Products API

export const createProductsApi = (payload) => {
  return API.post("/products", payload).then((res) => res);
};

export const fetchProductsApi = (payload) => {
  return API.get("/products/", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const fetchProductsByIdApi = (payload) => {
  return API.get("/products/" + (payload.id || ""), { params: { countrySk: payload.countrySk } })
    .then((res) => res)
    .catch((error) => error);
};

export const updateProductsApi = (payload) => {
  return API.put(`/products/${payload.ProductSK}`, payload)
    .then((res) => res)
    .catch((error) => error);
};

export const filterProductsApi = (payload) => {
  return API.get(`/products/`, {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

// Combos

export const fetchCombosApi = (payload) => {
  return API.get("/combos/", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const fetchCombosFilterApi = (payload) => {
  return API.get(`/combos/`, {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const fetchCombosByIdApi = (payload) => {
  return API.get("/combos/" + (payload?.id || ""), { params: { countrySk: payload?.countrySk } })
    .then((res) => res)
    .catch((error) => error);
};

export const fetchComboProductsApi = (payload) => {
  return API.get("/comboproducts/", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const fetchComboEzdsApi = (payload) => {
  return API.get("/comboEzds/", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const createCombosApi = (payload) =>
  API.post(`/combos`, payload).then((res) => res);

export const deleteComboProductApi = (payload) => {
  return API.delete(
    `/combosproductsku/${payload.ComboProduct_ProductSK}`,
    payload
  )
    .then((res) => res)
    .catch((error) => error);
};

export const updateComboApi = (payload) =>
  API.put(`/combos/${payload.ComboSK}`, payload).then((res) => res);

// File Resubmission

export const fetchPendingApprovalAPi = (payload) => {
  return API.get("/resubmissions/", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const approveOrRejectFileApi = (payload) => {
  return API.put(`/resubmissions/${payload.ResubmitApprovalSK}`, payload)
    .then((res) => res)
    .catch((error) => error);
};

export const filterFileApprovals = (payload) => {
  return API.get(`/resubmissions/`, {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

// Get EZDs

export const fetchEzds = (payload) => {
  return API.get("/ezds/", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

// Key Pos

export const fetchKeyPosApi = (payload) => {
  return API.get("/keyPoss/", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const fetchKeyPosById = (id) => {
  return API.get("/keyPoss/" + (id || ""))
    .then((res) => res)
    .catch((error) => error);
};

export const createChildPosApi = (payload) => {
  return API.post("/keyPoss/", payload).then((res) => res);
};

export const updateKeyPosApi = (payload) => {
  return API.put(`/keyPoss/${payload.POSSK}`, payload).then((res) => res);
};

export const filterKeyPosApi = (payload) => {
  return API.get(`/keyPoss/`, {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const fetchDynamicFieldControlApi = (payload) => {
  return API.get("/keyPoss/get-keypos-load-options", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

// Pos Decentralized

export const fetchPosDecentralized = (payload) => {
  return API.get("/decentralize/", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const fetchDecentralizedFilterApi = (payload) => {
  return API.get(`/decentralize/`, {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const fetchDecentralizedByIdApi = (id) => {
  return API.get("/decentralize/" + (id || ""))
    .then((res) => res)
    .catch((error) => error);
};

export const addChildPosApi = (payload) => {
  return API.post("/decentralize/", payload)
    .then((res) => res)
    .catch((error) => error);
};

export const updateChildPosApi = (payload) => {
  return API.put(`/decentralize/${payload.POSSK}`, payload)
    .then((res) => res)
    .catch((error) => error);
};

// Pos Survey

export const fetchSurveyPosApi = (payload) => {
  return API.get("/surveys/", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const filterSurveyPosApi = (payload) => {
  return API.get(`/surveys/`, {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const fetchSurveyByIdApi = (id) => {
  return API.get("/surveys/" + (id || ""))
    .then((res) => res)
    .catch((error) => error);
};

export const submitPosSurveyApi = (payload) => {
  return API.put(`/surveys/${payload.SurveySK}`, payload)
    .then((res) => res)
    .catch((error) => error);
};

//GeoTree

export const fetchGeotreesApi = (payload) => {
  return API.get("/geotrees/", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const getJobFunctionApi = (payload) => {
  return API.get("/jobfunctions/", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const filterGeoTreeApi = (payload) => {
  return API.get("/geotrees/", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const fetchGoeTreeByIdApi = (payload) => {
  return API.get("/geotrees/" + (payload?.id || ""), { params: { countrySk: payload.countrySk } })
    .then((res) => res)
    .catch((error) => error);
};

export const updateGeoTreeApi = (payload) => {
  return API.put(`/geotrees/${payload.PositionSK}`, payload).then((res) => res);
};

export const addGeoTreeApi = (payload) => {
  return API.post("/geotrees/", payload).then((res) => res);
};

export const getemployeesApi = (payload) => {
  return API.get("/getemployees/", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const fetchPositionsApi = (payload) => {
  return API.get("/getPositionDesc/", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

//Ezds

export const fetchEzdsApi = (payload) => {
  return API.get("/ezdss", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const filterEzdApi = (payload) => {
  return API.get("/ezdss/", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const fetchEzdsByIdAPI = (id) => {
  return API.get("/ezdss/" + (id || ""))
    .then((res) => res)
    .catch((error) => error);
};

export const addEzdBranchAPI = (payload) => {
  return API.post("/branchs/", payload).then((res) => res);
};

export const getEzdBranchByIdAPI = ({ BranchSK, BranchCode }) => {
  return API.get(`/branchs/${BranchCode}`, {
    params: {
      branchSK: BranchSK,
    },
  }).then((res) => res);
};

export const editEzdBranchAPI = (payload) => {
  return API.put(`/branchs/${payload.BranchSK}`, payload).then((res) => res);
};

// Sellout File Resubmission

export const fetchSelloutPendingApprovalAPi = (payload) => {
  return API.get("/sellout-resubmissions/", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const selloutApproveOrRejectFileApi = (payload) => {
  return API.put(`/sellout-resubmissions/${payload.ResubmitApprovalSK}`, payload)
    .then((res) => res)
    .catch((error) => error);
};

export const selloutFilterFileApprovals = (payload) => {
  return API.get(`/sellout-resubmissions/`, {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

// Sellout file upload
export const fetchSelloutUploadImdlAPI = (payload) => {
  return API.get("/sellout-file-submission/sellout-imdl-roles", {
    params: payload,
  })
    .then((res) => res)
    .catch((error) => error);
};

export const selloutGetUploadUrl = (payload) => {
  return API.post("/sellout-file-submission/sellout-get-upload-url", payload)
    .then((res) => res)
    .catch((error) => error);
}

export const selloutUploadFile = async (payload) => {
  try {
    await axios.put(payload.uploadUrl, payload.file, {
      headers: {
        "Content-Type": payload.file.type,
      },
    });

    console.log("✅ File uploaded successfully to S3");
    return true;
  } catch (err) {
    console.error("❌ Error uploading file:", err);
    return Promise.reject(err)
  }
}

// Validation rules apis
export const fetchValidationRules = (payload) => {
  return API.get("/validation-rules", {
    params: payload,
  })
    .then((res) => res);
};

export const getValidationRulesByID = (payload) => {
  return API.get(`/validation-rules/${payload?.id}`)
    .then((res) => res);
};

export const updateValidationRules = (payload) => {
  return API.put(`/validation-rules/${payload.ValidationSk}`, payload)
    .then((res) => res);
};